<template>
    <div class="d-flex flex-wrap align-items-center justify-content-center">
        
        <div v-if="!loading" class="d-flex flex-wrap align-items-center justify-content-center">
            <div class="d-flex align-items-center my-2" v-for="(menu, index) in menus" :key="index">
                <b-button 
                    @click="openRoute(menu.rota)" 
                    variant="primary" 
                    v-if="menu.rota" 
                    class="mx-2" 
                    style="width: 190px;"
                >
                    <i :class="`fas ${menu.icon} mx-2`"></i>
                    {{ limitarString(menu.label, 13) }}
                </b-button>
                <b-dropdown style="width: 190px;" v-else variant="primary" id="dropdown-1" class="mx-2 align-items-center">
                    <template #button-content>
                        <i :class="`fas ${menu.icon} mx-2`"></i>{{limitarString(menu.label, 13)}}
                    </template>
                    <b-dropdown-item 
                        @click="openRoute(submenu.rota)" 
                        variant="primary" 
                        v-for="(submenu, index_sub) in menu.submenus" 
                        :key="index_sub"
                    >
                        {{ submenu.label }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="skeletons d-flex flex-wrap align-items-center justify-content-center" v-else>
            <div v-for="n in 5" :key="n" class="skeleton-item mx-2 my-2"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return{
            menus: [],
            loading: true 
        }
    },
    mounted(){
        this.getMenusFavorites()
    },
    methods:{
        limitarString(texto, limite) {
            if (!texto) {
                return "";
            }
            if (texto.length <= limite) {
                return texto;
            }
            const textoCortado = texto.slice(0, limite);
            return textoCortado + "...";
        },
        openRoute(route){
            window.open(route, '_self');
        },
        getMenusFavorites(){
            axios
                .get("/get_favorites")
                .then(resp => {
                    if(resp.data){
                        resp.data.forEach(element => {
                            if(element.menu){
                                this.menus.push(element.menu)
                            }else{
                                this.menus.push(element)
                            }
                        })
                    }
                })
                .catch(error => {
                    console.error("Erro ao buscar menus:", error);
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>

<style scoped>
/* Estilo base para cada item do skeleton */
.skeleton-item {
    width: 190px;
    height: 40px;
    background-color: #e0e0e027; /* Cor de fundo cinza claro */
    border-radius: 0.25rem; /* Bordas arredondadas para combinar com os botões */
    
    /* Animação de brilho (shimmer) */
    background-image: linear-gradient(
        90deg, 
        #e0e0e027 0px, 
        #f5f5f57e 40px, 
        #e0e0e027 80px
    );
    background-size: 600px; /* Tamanho do gradiente */
    animation: shimmer 2s infinite linear;
}

/* Animação que move o gradiente de fundo */
@keyframes shimmer {
    0% {
        background-position: -400px 0;
    }
    100% {
        background-position: 400px 0;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/adm_horizontal_navbar/Main.vue